import Vue from 'vue'
import App from './App.vue'
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons'
import 'bootstrap-icons/font/bootstrap-icons.css'

import store from './store/store.js'
// import Loading from 'vue-loading-overlay'
// import 'vue-loading-overlay/dist/vue-loading.css'
import './style/global.css'
import router from './router'
// import { BootstrapVue } from 'bootstrap-vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import { Ripple } from 'vuetify/lib/directives'
const MessageBox = () =>
  import(
    /* webpackChunkName: "common-message-box" */
    './components/commons/MessageBox.vue'
  )
const NavBar = () =>
  import(
    /* webpackChunkName: "common-navbar" */
    './components/commons/NavBar.vue'
  )
const PageHeading = () =>
  import(
    /* webpackChunkName: "common-page-heading" */
    './components/commons/PageHeading.vue'
  )
const PoweredBy = () =>
  import(
    /* webpackChunkName: "common-powered-by" */
    './components/commons/PoweredBy.vue'
  )
const ConsentBox = () =>
  import(
    /* webpackChunkName: "common-consent-box" */
    './components/commons/ConsentBox.vue'
  )
const InfoMessage = () =>
  import(
    /* webpackChunkName: "common-info-message" */
    './components/commons/InfoMessage.vue'
  )
const StepNavigator = () =>
  import(
    /* webpackChunkName: "common-step-navigator" */
    './components/commons/StepNavigator.vue'
  )
const LoadIng = () =>
  import(
    /* webpackChunkName: "common-loading" */
    './components/commons/LoadIng.vue'
  )
const FailureScreen = () =>
  import(
    /* webpackChunkName: "common-failure-screen" */
    './components/commons/FailureScreen.vue'
  )
Vue.config.productionTip = false
// Vue.use(BootstrapVue)
Vue.component('load-ing', LoadIng)
Vue.component('MessageBox', MessageBox)
Vue.component('NavBar', NavBar)
Vue.component('PageHeading', PageHeading)
Vue.component('PoweredBy', PoweredBy)
Vue.component('ConsentBox', ConsentBox)
Vue.component('InfoMessage', InfoMessage)
Vue.component('StepNavigator', StepNavigator)
Vue.component('FailureScreen', FailureScreen)
Vue.use(Vuetify)
new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify: new Vuetify({
    directives: {
      Ripple,
    },
    theme: {
      themes: {
        light: {
          colors: {
            primary: '#1E88E5', // Blue primary color
            secondary: '#8E24AA', // Purple secondary color
            accent: '#FFC107', // Yellow accent color
            background: '#F5F5F5', // Light background color
            surface: '#FFFFFF', // Card/Component background color
            error: '#D32F2F', // Error color
            info: '#1976D2', // Info color
            success: '#388E3C', // Success color
            warning: '#F57C00', // Warning color
          },
        },
      },
    },
  }),
}).$mount('#app')
